import { Facebook, Pinterest, Telegram, WhatsApp, X } from "@mui/icons-material";
import "./footer.css";
import { Link } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { useSettingsContext } from "../../hooks/useSettingsContext";

function Footer() {
  const {data, error} = useFetchData("settings");
  console.log("footer : ",data);
  const {settings} = useSettingsContext();
  
  return (
    <>
      <footer id="footer" style={{background: settings?.color?.secondary ? settings?.color?.secondary : "#ebd0b3"}} className="pr" dir="rtl">
        <img src="/img/hiddenbg.png" className="hiddenbg" srcSet="" />
        <div className="container-padding mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-16">
            {/* First Column - Logo and About Section */}
            <div className="flex flex-col items-start ta-c">
              <a href="index.html" className="mx-auto">
                <img
                  src={ settings?.logo?.url ? settings?.logo?.url : "/img/logo.png"}
                  alt="Logo"
                  className="w-32 h-auto mb-4"
                />
              </a>
              <div className="footer-about">
                <p className="text-sm">
                  في الرحيق نعمل بشغف لنقدّم لك عسلًا طبيعيًا نقيًا من قلب مناحل حضرموت، حيث نقوم باختيار أفضل الخلايا وإنتاج العسل وفق أعلى المعايير.
نؤمن أن العسل يجب أن يكون غذاءً يوميًا في كل بيت، لذلك نوصل إليك عسلاً خامًا ذو جودة عالية، مباشرة من خلايا النحل دون أي إضافات أو مواد حافظة.
                </p>
              </div>
            </div>

            {/* Second Column - Useful Links */}
            <div className="flex flex-col">
              <h2 className="text-lg font-semibold mb-2">روابط مفيدة</h2>
              <img
                src="./assets/images/about/home_line.png"
                alt=""
                className="w-24 mb-4"
              />
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="flex items-center">
                    <i className="fa-solid fa-angles-right mr-2"></i> الرئيسية
                  </Link>
                </li>
                <li>
                  <Link to="/honey-products" className="flex items-center">
                    <i className="fa-solid fa-angles-right mr-2"></i> منتجات العسل
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="flex items-center">
                    <i className="fa-solid fa-angles-right mr-2"></i> الشروط والأحكام
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="flex items-center">
                    <i className="fa-solid fa-angles-right mr-2"></i> تواصل معنا
                  </Link>
                </li>
                <li>
                  <a  href="https://drive.google.com/file/d/1FMi5kI6xoq8dexw66o7RLZUSDyjT2Wqo/view" target="_blank" className="flex items-center">
                    <i className="fa-solid fa-angles-right mr-2"></i> أقرأ كتابنا
                  </a>
                </li>
                <li>
                  <Link  to="apply" target="_blank" className="flex items-center">
                    <i className="fa-solid fa-angles-right mr-2"></i> التقديم كمندوب
                  </Link>
                </li>
              </ul>
            </div>

            {/* Third Column - Social Media Links */}
            <div className="flex flex-col items-center">
              <h2 className="text-lg font-semibold mb-2">تابعونا</h2>
              <img
                src="./assets/images/about/home_line.png"
                alt=""
                className="w-24 mb-4"
              />
        <div className="media-buttons df !gap-1 sm-mx-auto" target="_blank">
  <a
    href="https://wa.me/967777802213"
    target="_blank"
    rel="noopener noreferrer"
    className="link"
    style={{ backgroundColor: "#25D366" }} /* WhatsApp green */
  >
    <WhatsApp className="bx bxl-whatsapp"></WhatsApp>
  </a>
  <a
    href={data?.settings.social.facebook}
    target="_blank"
    className="link"
    style={{ backgroundColor: "#3b5998" }} /* Facebook blue */
  >
    <Facebook className="bx bxl-facebook"></Facebook>
  </a>
  <a
    href={data?.settings.social.twitter}
    target="_blank"
    className="link"
    style={{ backgroundColor: "#000000", padding:"2px" }} 
  >
    <X className="bx bxl-twitter"></X>
  </a>
  <a
    href={data?.settings.social.instagram}
    target="_blank"
    className="link"
    style={{ backgroundColor: "#0088CC" }} /* Telegram blue */
  >
    <Telegram className="bx bxl-telegram"></Telegram>
  </a>
  <a
    href={data?.settings.social.pinterest}
    target="_blank"
    className="link"
    style={{ backgroundColor: "#E60023" }} /* Pinterest red */
  >
    <Pinterest className="bx bxl-pinterest"></Pinterest>
  </a>
</div>

            </div>

            {/* Fourth Column - Address */}
            <div className="flex flex-col">
              <h2 className="text-lg font-semibold mb-2">العنوان</h2>
              <img
                src="./assets/images/about/home_line.png"
                alt=""
                className="w-24 mb-4"
              />
              <ul className="space-y-2">
                <li className="flex items-center">
                  <i className="fa-solid fa-location-dot mr-2"></i> حضرموت| دوعن
                </li>
                <li>
                  <a href="tel:+967777802213" className="flex items-center">
                    <i className="fa-solid fa-phone mr-2"></i> <span dir="ltr">+967 777802213</span>
                  </a>
                </li>
                <li>
                  <a href="tel:+967730181839" className="flex items-center">
                    <i className="fa-solid fa-phone mr-2"></i> <span dir="ltr">+967 730181839</span>
                  </a>
                </li>
                <li>
                  <a href="" className="flex items-center">
                    <i className="fa-solid fa-envelope mr-2"></i> Info@alrheeq.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
